<template>
  <div v-if="isWarning">
    <title-screen title="13"></title-screen>
    <div v-text="warningMessage">
    </div>
  </div>
  <div v-else class="">
    <confirm-change-before-route ref="confirm-before-route">
    <el-form-custom class="form mt2 form-register member-register" ref="member" :model="member" :rules="rules" v-show="formRegister">
      <table class="table-register">
        <tr>
          <th id="name" class="column-label required">{{ $t('member.name') }}</th>
          <td class="column-input">
            <div class="d-flex">
              <el-form-item-custom prop="lastName" class="w-45p mr-auto "><input type="text" v-model="member.lastName" placeholder="姓" class="input"></el-form-item-custom>
              <el-form-item-custom prop="firstName" class="w-45p "><input type="text" v-model="member.firstName" placeholder="名" class="input"></el-form-item-custom>
            </div>
          </td>
        </tr>
        <tr>
          <th id="name-kana" class="column-label required">{{ $t('member.name_kana') }}</th>
          <td class="column-input">
            <div class="d-flex">
              <el-form-item-custom prop="lastNameKana" class="w-45p mr-auto "><input type="text" v-model="member.lastNameKana" placeholder="セイ" class="input"></el-form-item-custom>
              <el-form-item-custom prop="firstNameKana" class="w-45p "><input type="text" v-model="member.firstNameKana" placeholder="メイ" class="input"></el-form-item-custom>
            </div>
          </td>
        </tr>
        <tr>
          <th id="gender" class="column-label required">{{ $t('member.gender') }}</th>
          <td class="column-input">
            <el-form-item-custom prop="gender" class="form-item-radio">
              <el-radio-group v-model="member.gender">
                <el-radio :key="1" :label="'1'">{{ $t('commons.male') }}</el-radio>
                <el-radio :key="2" :label="'2'">{{ $t('commons.female') }}</el-radio>
              </el-radio-group>
            </el-form-item-custom>
          </td>
        </tr>
        <tr>
          <th id="phone" class="column-label">{{ $t('member.phone') }}</th>
          <td class="column-input max-width-220 tel">
            <el-form-item-custom prop="phone">
              <input type="text" class="input mr-3" v-model="member.phone" placeholder="03-xxxx-xxxx">
              <span class="d-inline-block">半角で、ハイフンを含めて登録してください</span>
            </el-form-item-custom>
          </td>
        </tr>
        <tr>
          <th id="mobile-phone" class="column-label">{{ $t('member.mobile_phone') }}</th>
          <td class="column-input max-width-220 tel">
            <el-form-item-custom prop="mobilePhone">
              <input type="text" class=" mr-3" :disabled="registerType === 'MOBILE_PHONE'" v-model="member.mobilePhone" placeholder="070-xxxx-xxxx">
              <span class="d-inline-block">半角で、ハイフンを含めて登録してください</span>
              <div class="el-form-item__error" v-if="msgDupMobilePhone.length !== 0">
                {{msgDupMobilePhone}}
              </div>
            </el-form-item-custom>
          </td>
        </tr>
        <tr>
          <th id="email" class="column-label">{{ $t('member.email') }}</th>
          <td class="column-input max-width-300">
            <el-form-item-custom prop="email" :class="msgDupEmail.length !== 0 ? 'pb-3' : ''">
              <input type="email" class="input" :disabled="registerType === 'EMAIL'" v-model="member.email" placeholder="xxxxxxx@legacy.ne.jp">
              <div class="el-form-item__error" v-if="msgDupEmail.length !== 0">
                {{msgDupEmail}}
              </div>
            </el-form-item-custom>
          </td>
        </tr>
        <tr class="login-id-row">
          <th id="login-id" class="column-label">
            {{ $t('member.login_id') }}
          </th>
          <td class="column-input max-width-400">
            <el-form-item-custom prop="loginId" class="">
              <input type="text" class="input" v-model="member.loginId" disabled>
              <span class="d-inline-block small-text">登録用メール・SMSでお送りしたメールアドレスまたは電話番号が、今後のログインIDとして自動的に設定されます</span>
              <el-checkbox class="cb" v-model="cbSaveLoginId">IDを保存する</el-checkbox>
              <div class="el-form-item__error" v-if="msgDupLoginId.length !== 0">
                {{msgDupLoginId}}
              </div>
            </el-form-item-custom>
          </td>
        </tr>
        <tr class="password-row">
          <th id="password" class="column-label required">
            {{ $t('member.password') }}
            <br>
            <span class="d-inline-block small-text">半角英数字記号すべて使用して、8～32文字</span>
            <br>
            <span class="d-inline-block small-text tooltip-text" v-tooltip.top-start="{ content: '利用可能記号: &#33;&#34;&#35;&#36;&#37;&#38;\'&#40;&#41;&#42;&#43;&#44;&#45;&#46;&#47;&#58;&#59;&#60;&#61;&#62;&#63;&#64;&#91;&#92;&#93;&#94;&#95;&#96;&#123;&#124;&#125;&#126;', classes: ['small-text'], trigger: 'hover click' }">※利用可能記号確認</span>
          </th>
          <td class="column-input max-width-400">
            <el-form-item-custom prop="password" class="">
              <input type="password" class="input" v-model="member.password">
              <span class="d-inline-block small-text">小文字と数字を含めて8～32文字で組み合わせて設定してください</span>
            </el-form-item-custom>
          </td>
        </tr>
        <tr>
          <th id="password-confirm" class="column-label required">{{ $t('member.password_confirm') }}</th>
          <td class="column-input max-width-400 password-confirm">
            <el-form-item-custom prop="passwordConfirm"><input type="password" class="input" v-model="member.passwordConfirm"></el-form-item-custom>
          </td>
        </tr>
        <tr>
          <th id="birthday-title" class="column-label required">{{ $t('member.birthday') }}</th>
          <td id="birthday" class="column-input xxs-input-birthday">
            <el-form-item-custom prop="birthday">
              <date-select @change="$refs['confirm-before-route'].change()" v-model="member.birthday" :defaultYear="defaultBirthdayYear"></date-select>
            </el-form-item-custom>
          </td>
        </tr>
        <tr>
          <th id="zip-code" class="column-label">{{ $t('member.zip_code') }}</th>
          <td class="column-input max-width-220">
            <el-form-item-custom prop="zipCode">
              <zip-code-input class="d-inline-block mr-3" v-model="member.zipCode"></zip-code-input>
            </el-form-item-custom>
          </td>
        </tr>
        <tr>
          <th id="prefecture" class="column-label required">{{ $t('member.prefecture') }}</th>
          <td class="column-input max-width-220">
            <el-form-item-custom prop="prefecture">
              <prefecture-select
                :changeAction="prefectureChange"
                v-model="member.prefecture"
                :prefectureMaster="prefectureMaster"
              ></prefecture-select>
            </el-form-item-custom>
          </td>
        </tr>
        <tr>
          <th id="address" class="column-label">{{ $t('member.address') }}</th>
          <td class="column-input max-width-400">
            <el-form-item-custom prop="address"><input type="text" v-model="member.address"></el-form-item-custom>
          </td>
        </tr>
        <tr>
          <th id="use-mail-magazine" class="column-label required">{{ $t('member.use_mail_magazine') }}</th>
          <td class="column-input max-width-220">
            <el-radio-group v-model="member.useMailMagazine">
              <el-radio :key="true" :label="true">{{ $t('commons.yes') }}</el-radio>
              <el-radio :key="false" :label="false">{{ $t('commons.no') }}</el-radio>
            </el-radio-group>
          </td>
        </tr>
      </table>
      <div class="button">
        <div class="checkbox-area">
          <el-checkbox v-model="isAgreeMemberAgreement" :class="checkPolicyClass" @change="handlePolicy">
            <a href="https://legacy.ne.jp/privacy-customer/" target="_blank" rel="noopener noreferrer">
                <span class="active-link">{{ $t('words.member.agree_member_agreement') }}</span>
            </a>
          </el-checkbox><br>
          <div class="warning-policy" v-if="checkPolicy">
              「『個人情報の取扱いについて』同意します」にチェックしてください。
          </div>
          <el-checkbox v-model="isAgreeTermsOfService" :class="checkTermClass" @change="handleTerm">
            <router-link to="/termsOfService" target="_blank">
              <span class="active-link"> {{ $t('words.member.agree_terms_of_service') }}</span>
            </router-link>
          </el-checkbox>
          <div class="warning-term" v-if="checkTerm">
              「利用規約に同意します」にチェックしてください。
           </div>
<!--          <input type="checkbox" checked v-model="isAgreeMemberAgreement"><router-link to="/privacyPolicy" target="_blank"><span class="active-link"> {{ $t('words.member.agree_member_agreement') }}</span></router-link><br>-->
<!--          <input type="checkbox" checked v-model="isAgreeTermsOfService"><router-link to="/termsOfService" target="_blank"><span class="active-link"> {{ $t('words.member.agree_terms_of_service') }}</span></router-link>-->
        </div>
        <div class="mt2 text-center">
          <el-button @click="resetForm('member')">{{ $t('commons.clear') }}</el-button>
          <el-button @click="submitForm('member')">{{ $t('commons.register') }}</el-button>
        </div>
      </div>
    </el-form-custom>
    </confirm-change-before-route>
    <el-form class="form mt2" ref="dataConfirm" :class="dataConfirm ? 'form-confirm' : ''" :model="dataConfirm" v-show="!formRegister">
      <table class="table-register">
        <tr>
          <th id="cf-name" class="column-label"><p>{{ $t('member.name') }}</p></th>
          <td class="column-input">
            <p class="d-inline-block mr-3">{{dataConfirm.lastName}}</p>
            <p class="d-inline-block">{{dataConfirm.firstName}}</p>
          </td>
        </tr>
        <tr>
          <th id="cf-name-kana" class="column-label">{{ $t('member.name_kana') }}</th>
          <td class="column-input">
            <p class="d-inline-block mr-3">{{dataConfirm.lastNameKana}}</p>
            <p class="d-inline-block">{{dataConfirm.firstNameKana}}</p>
          </td>
        </tr>
        <tr>
          <th id="cf-gander" class="column-label">{{ $t('member.gender') }}</th>
          <td class="column-input">
            <el-form-item prop="gender">
              <p>{{dataConfirm.gender}}</p>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <th id="cf-phone" class="column-label">{{ $t('member.phone') }}</th>
          <td class="column-input max-width-400">
            <p>{{dataConfirm.phone}}</p>
          </td>
        </tr>
        <tr>
          <th id="cf-mobile-phone" class="column-label">{{ $t('member.mobile_phone') }}</th>
          <td class="column-input max-width-400">
            <p>{{dataConfirm.mobilePhone}}</p>
          </td>
        </tr>
        <tr>
          <th id="cf-email" class="column-label">{{ $t('member.email') }}</th>
          <td class="column-input max-width-400">
            <p>{{dataConfirm.email}}</p>
          </td>
        </tr>
        <tr>
          <th id="cf-login-id" class="column-label">{{ $t('member.login_id') }}</th>
          <td class="column-input max-width-400">
            <p>{{dataConfirm.loginId}}</p>
            <el-checkbox class="cb" v-model="cbSaveLoginId" disabled>IDを保存する</el-checkbox>
          </td>
        </tr>
        <tr>
          <th id="cf-password" class="column-label">{{ $t('member.password') }}</th>
          <td class="column-input max-width-400">
            <p>********</p>
          </td>
        </tr>
        <tr>
          <th id="cf-password-confirm" class="column-label">{{ $t('member.password_confirm') }}</th>
          <td class="column-input max-width-400">
            <p>********</p>
          </td>
        </tr>
        <tr>
          <th id="cf-birthday" class="column-label">{{ $t('member.birthday') }}</th>
          <td>
            <p>{{dataConfirm.birthday}}</p>
          </td>
        </tr>
        <tr>
          <th id="cf-zip-code" class="column-label">{{ $t('member.zip_code') }}</th>
          <td class="column-input max-width-220">
            <p>{{dataConfirm.zipCode}}</p>
          </td>
        </tr>
        <tr>
          <th id="cf-prefecture" class="column-label">{{ $t('member.prefecture') }}</th>
          <td class="column-input max-width-220">
            <p>{{dataConfirm.prefecture}}</p>
          </td>
        </tr>
        <tr>
          <th id="cf-address" class="column-label">{{ $t('member.address') }}</th>
          <td class="column-input max-width-220">
            <p>{{dataConfirm.address}}</p>
          </td>
        </tr>
        <tr>
          <th id="cf-use-mail-magazine" class="column-label">{{ $t('member.use_mail_magazine') }}</th>
          <td class="column-input max-width-220">
            <p>{{dataConfirm.useMailMagazine}}</p>
          </td>
        </tr>
      </table>
      <div class="button">
        <div class="mt2 text-center">
          <el-button @click="backForm">{{ $t('commons.back') }}</el-button>
          <el-button @click="registerForm" :disabled="!isRegistrable">{{ $t('commons.register') }}</el-button>
        </div>
      </div>
    </el-form>
    <confirm-dialog
      ref="confirm-reset-form"
    ></confirm-dialog>
    <div>
    </div>
  </div>
</template>

<script>
import memberApi from '@/api/member/member-client.js'
import DecryptApi from '@/api/decrypt'
import ConfirmDialog from '@/components/dialog/ConfirmDialog'
import moment from 'moment'
import TitleScreen from '../../../../components/common/TitleScreen'
import ContactApi from '@/api/contact/contact-cl'
import DateSelect from '../../../../components/common/DateSelect'
import ZipCodeInput from '../../../../components/common/ZipCodeInput'
import ConfirmChangeBeforeRoute from '../../../../components/common/ConfirmChangeBeforeRoute'
import { applySessionFromResponse } from '@/common/authSession'
import messageFormErrUtil from './messageFormErrUtil'
import PrefectureSelect from '@/components/common/PrefectureSelect'
import saveLoginIdMixin from '../../../../mixins/saveLoginIdMixin'
import { isExpired } from './registrationLinkExpiry'

export default {
    name: 'MemberRegister',
    mixins: [messageFormErrUtil, saveLoginIdMixin],
    components: {
      ConfirmChangeBeforeRoute,
      ZipCodeInput,
      DateSelect,
      TitleScreen,
      ConfirmDialog,
      PrefectureSelect
    },
    data () {
        const passwordConfirm = (rule, value, callback) => {
            if (value !== this.member.password) {
                callback(new Error('パスワード（確認）とパスワードが一致しません'))
            } else {
                callback()
            }
        }
        const validateDate = (rule, value, callback) => {
          if (!moment(value, 'YYYY-MM-DD', true).isValid()) {
            callback(new Error('正しい日付を選択してください'))
          } else {
            callback()
          }
        }

        return {
            member: {
                loginId: '',
                password: '',
                lastName: '',
                passwordConfirm: '',
                firstName: '',
                lastNameKana: '',
                firstNameKana: '',
                email: '',
                phone: '',
                mobilePhone: '',
                zipCode: '',
                prefecture: '',
                address: '',
                gender: '',
                birthday: '',
                useMailMagazine: true
            },
            rules: {
                // login_id is auto-filled from the registration link's email/phone and disabled,
                // so this is just a required check, not a shape/length rule - the backend
                // (MemberController.create) derives the real value server-side regardless of
                // what this form submits.
                loginId: [
                    { required: true, message: '本人確認リンクの読み込みに失敗しました。お手数ですが、登録用メールまたはSMSのリンクからやり直してください。', trigger: 'blur' }
                ],
                lastName: [
                    { required: true, message: this.$t('rules.required', { key: this.$t('member.last_name') }), trigger: 'blur' },
                    { max: 50, message: '50文字以内で入力してください' }
                ],
                firstName: [
                    { required: true, message: this.$t('rules.required', { key: this.$t('member.first_name') }), trigger: 'blur' },
                    { max: 50, message: '50文字以内で入力してください' }
                ],
                lastNameKana: [
                    { pattern: /^[ァ-ンヴー]+$/, message: '全角カタカナで入力してください' },
                    { max: 50, message: '50文字以内で入力してください' },
                    { required: true, message: this.$t('rules.required', { key: this.$t('member.last_name_kana') }), trigger: 'blur' }
                ],
                firstNameKana: [
                    { pattern: /^[ァ-ンヴー]+$/, message: '全角カタカナで入力してください' },
                    { max: 50, message: '50文字以内で入力してください' },
                    { required: true, message: this.$t('rules.required', { key: this.$t('member.first_name_kana') }), trigger: 'blur' }
                ],
                gender: [
                    { required: true, message: this.$t('rules.no_select', { key: this.$t('member.gender') }), trigger: 'change' }
                ],
                email: [
                    { required: false, pattern: /^[a-zA-Z0-9]{1}[a-zA-Z0-9_.-]*@{1}(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|([a-zA-Z0-9_.-]{1,}\.[a-zA-Z0-9]{2,}))$/, message: this.$t('rules.email'), trigger: 'blur' }
                ],
                phone: [
                    { required: false, pattern: /^(?:\d{2}-\d{4}|\d{3}-\d{3}|\d{4}-\d{2}|\d{5}-\d)-\d{4}$/, message: this.$t('rules.number', { key: this.$t('member.phone') }), trigger: 'blur' }
                ],
                mobilePhone: [
                    { required: false, pattern: /^\d{3}-\d{4}-\d{4}$/, message: this.$t('rules.number', { key: this.$t('member.mobile_phone') }), trigger: 'blur' }
                ],
                zipCode: [
                    { required: false, pattern: /^[0-9]{3}-[0-9]{4}$/, message: this.$t('rules.zip_code'), trigger: 'blur' }
                ],
                birthday: [
                    { validator: validateDate, trigger: 'blur' }
                ],
                password: [
                  { required: true,
                    // Mirrors PasswordPolicy.kt: 8+ chars, lowercase+digit required, "¥" forbidden.
                    pattern: /^(?=.*[a-z])(?=.*\d)[^¥]{8,32}$/,
                    message: '小文字と数字を含めて8文字以上で入力してください',
                    trigger: 'blur'
                  }
                ],
                passwordConfirm: [
                    { validator: passwordConfirm, trigger: 'blur' }
                ],
                prefecture: [
                    { required: true, message: this.$t('rules.no_select', { key: this.$t('member.prefecture') }), trigger: 'blur' }
                ],
                address: [
                    { required: false, max: 200, message: '200文字以内で入力してください', trigger: 'blur' }
                ]
            },
            isAgreeMemberAgreement: false,
            isAgreeTermsOfService: false,
            dataConfirm: {},
            formRegister: true,
            isDate: '',
            isGender: '',
            isUseMail: '',
            isWarning: false,
            isError: false,
            needCheck: false,
            prefectureMaster: [],
            registerType: null,
            registerValue: null,
            linkCode: null,
            warningMessage: '',
            expiredMessage: 'このURLは有効期限が切れているか、無効です。',
            msgDupEmail: '',
            msgDupMobilePhone: '',
            msgDupLoginId: '',
            checkPolicy: false,
            checkTerm: false
        }
    },
    computed: {
        isRegistrable: function () {
          return this.isAgreeTermsOfService && this.isAgreeMemberAgreement
        },
        defaultBirthdayYear: function () {
            return '1960'
        },
        checkPolicyClass: function () {
            return this.checkPolicy ? 'is-error' : ''
        },
        checkTermClass: function () {
            return this.checkTerm ? 'is-error' : ''
        }
    },
    created () {
      const code = this.$route.query.code
      if (!code) {
        this.isWarning = true
        this.warningMessage = this.expiredMessage
        return
      }
      this.linkCode = code
      this.loadDecryptCode(code)
      this.loadPrefecture()
    },
    beforeUpdate () {
      if (this.needCheck) {
        this.$refs['member'].validate((valid) => {
            if (valid) {
                this.isError = false
            } else {
                this.msgDupLoginId = ''
                this.msgDupEmail = ''
                this.msgDupMobilePhone = ''
                this.isError = true
            }
        })
      }
    },
    methods: {
        async loadDecryptCode (code) {
          try {
            const res = await DecryptApi.getDecrypt(code, 'MEMBER-REGISTER')
            const { registerType, registerValue, requestTime } = res.data

            if (isExpired(requestTime, new Date())) {
              this.isWarning = true
              this.warningMessage = this.expiredMessage
            }

            this.registerType = registerType
            this.registerValue = registerValue
            // login_id always matches the registration link's own identifier - it's not a
            // free-typed, user-chosen ID.
            this.member.loginId = registerValue
            if (registerType === 'EMAIL') {
              this.member.email = registerValue
            }
            if (registerType === 'MOBILE_PHONE') {
              this.member.mobilePhone = registerValue
            }

            // Non-blocking landing-time collision check: if the link's own identifier already
            // has an account, route to login instead of letting the user fill out the whole
            // form first.
            if (!this.isWarning) {
              await this.checkLandingCollision(code, registerValue)
            }
          } catch (e) {
            this.isWarning = true
            this.warningMessage = this.expiredMessage
          }
        },
        async checkLandingCollision (code, registerValue) {
          try {
            const res = await memberApi.checkRegistrationCollision(code)
            if (res && res.hasCollision) {
              // Route through the portal's own sessionViolation query-param handling (rather
              // than dispatching SET_OPEN_LOGIN_DIALOG directly here) so the dialog opens only
              // after that navigation's own CHECK_AUTH_CLIENT has settled - dispatching before
              // that point gets the dialog immediately closed again by PURGE_AUTH_CLIENT.
              this.$router.push({ name: 'portal', query: { accountExists: '1', loginId: registerValue } })
            }
          } catch (e) {
            // Fails open: an unreachable Cognito or invalid code never blocks here - the input
            // screen's own collision check and the final submit's own check are the safety net.
          }
        },
        async loadPrefecture () {
          const res = await ContactApi.getInformPrefectureMaster()
          this.prefectureMaster = res.data.data
        },
        prefectureChange () {
            this.$refs['confirm-before-route'].change()
        },
        alertMessage (message, title) {
            this.$alert(message, title, {
                confirmButtonText: this.$t('commons.ok')
            })
        },
        async submitForm (formName) {
            this.needCheck = true
            this.msgDupLoginId = ''
            this.msgDupEmail = ''
            this.msgDupMobilePhone = ''
            this.checkPolicy = !this.isAgreeMemberAgreement
            this.checkTerm = !this.isAgreeTermsOfService
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isDuplicate().then(() => {
                        if (!this.isRegistrable) {
                            this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー')
                            return false
                        }
                        this.dataConfirm = this.member
                        if (this.member.gender === '1') {
                            this.dataConfirm.gender = '男性'
                        } else {
                            this.dataConfirm.gender = '女性'
                        }
                        if (this.member.useMailMagazine === true || this.member.useMailMagazine === 'true') {
                            this.dataConfirm.useMailMagazine = 'はい'
                        } else {
                            this.dataConfirm.useMailMagazine = 'いいえ'
                        }
                        this.isDate = this.member.birthday
                        this.isGender = this.member.gender
                        this.isUseMail = this.member.useMailMagazine
                        this.dataConfirm.birthday = moment(this.dataConfirm.birthday).locale('ja').format('YYYY年MM月DD日')
                        this.formRegister = false
                    }).catch(() => this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー'))
                } else {
                    this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー')
                }
            })
        },
        resetForm (formName) {
            this.$refs['confirm-reset-form'].open({
              message: '入力内容がクリアされますがよろしいですか？'
            }).then((confirm) => {
              if (confirm) {
                this.isAgreeTermsOfService = false
                this.isAgreeMemberAgreement = false
                this.$refs[formName].resetFields()
                this.member.loginId = this.registerValue
                if (this.registerType === 'EMAIL') {
                  this.member.email = this.registerValue
                }
                if (this.registerType === 'MOBILE_PHONE') {
                  this.member.mobilePhone = this.registerValue
                }
              }
            })
        },
        backForm () {
            this.formRegister = true
            this.member.birthday = this.isDate
            if (this.dataConfirm.gender === '男性') {
                this.member.gender = '1'
            } else {
                this.member.gender = '2'
            }
            if (this.dataConfirm.useMailMagazine === 'はい') {
                this.member.useMailMagazine = true
            } else {
                this.member.useMailMagazine = false
            }
        },
        registerForm () {
            let requestData = Object.assign({}, this.dataConfirm)
            delete requestData.passwordConfirm
            requestData.code = this.linkCode
            requestData.birthday = moment(this.isDate).format('YYYY-MM-DD')
            if (this.isGender === '男性') {
                requestData.gender = '1'
            } else {
                requestData.gender = '2'
            }
            if (this.isUseMail === 'はい') {
                requestData.useMailMagazine = true
            } else {
                requestData.useMailMagazine = false
            }
            memberApi.create(requestData).then(response => {
                this.doSaveLoginId(this.member.loginId)
                this.$refs['confirm-before-route'].reset()
                // POST /member/create already returns an IDENTITY_VERIFICATION_REQUIRED-flagged
                // JWT/refresh-token pair - use it directly rather than a second POST /member/login.
                //
                // applySessionFromResponse is async (it calls GET /member/selfInfo) and must be
                // awaited before navigating - otherwise the router's global guard can run first,
                // find a saved token but no saved user yet, and purge the session mid-flow.
                return applySessionFromResponse(this.$store, response).then(() => {
                    this.$alert('ご登録ありがとうございました。続いて本人確認を行ってください。', '', {
                        confirmButtonText: '本人確認へ進む',
                        center: true,
                        confirmButtonClass: 'btn-msg-box'
                    }).then(() => {
                        this.$router.push({ name: 'identityVerification' })
                    }).catch(() => {})
                })
            }).catch(error => {
                if (requestData.gender === '1') {
                    this.dataConfirm.gender = '男性'
                } else {
                    this.dataConfirm.gender = '女性'
                }
                this.alertMessage(error.response.data.message, 'エラー')
            })
        },
        isDuplicate () {
            return new Promise((resolve, reject) => {
                let data = {
                    'loginId': this.member.loginId,
                    'email': this.member.email,
                    'mobilePhone': this.member.mobilePhone
                }
                memberApi.validateDuplicate(data).then(res => {
                    if (res.data !== null && Object.keys(res.data).length !== 0) {
                        this.msgDupLoginId = res.data.loginId ? res.data.loginId : ''
                        this.msgDupEmail = res.data.email ? res.data.email : ''
                        this.msgDupMobilePhone = res.data.mobilePhone ? res.data.mobilePhone : ''
                    }
                    if (this.msgDupLoginId.length !== 0 || this.msgDupMobilePhone.length !== 0 || this.msgDupEmail.length !== 0) {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        reject()
                        return
                    }
                    this.checkCognitoCollision().then(resolve).catch(reject)
                }).catch(err => {
                    this.showMsgError(this, 'member', err.response.data.message)
                })
            })
        },
        // Checks Cognito for a collision on the registration link's own identifier, after the
        // local-DB check (isDuplicate) already passed. Fails open on a Cognito outage or an
        // invalid code - the confirmation screen's own fail-closed submit-time check
        // (cognitoBlocksSubmission) is the last safety net for that case.
        checkCognitoCollision () {
            return new Promise((resolve, reject) => {
                memberApi.checkRegistrationCollision(this.linkCode).then(res => {
                    if (res && res.hasCollision) {
                        const message = 'こちらの情報は既に会員登録されています。'
                        if (this.registerType === 'MOBILE_PHONE') {
                            this.msgDupMobilePhone = message
                        } else {
                            this.msgDupEmail = message
                        }
                        // eslint-disable-next-line prefer-promise-reject-errors
                        reject()
                        return
                    }
                    resolve()
                }).catch(() => {
                    // Fails open: an unreachable Cognito or invalid code never blocks here.
                    resolve()
                })
            })
        },
        handlePolicy () {
            this.checkPolicy = !this.isAgreeMemberAgreement
        },
        handleTerm () {
            this.checkTerm = !this.isAgreeTermsOfService
        }
    },
    beforeRouteLeave (to, from, next) {
        if (this.isWarning) {
            next()
        } else {
          this.$refs['confirm-before-route'].openConfirm().then((confirm) => {
            if (confirm) {
              next()
            } else {
              next(false)
            }
          })
        }
    }
}
</script>

<style>
  @import 'member_register.css';
  @import "../../../../assets/css/client_custom.css";
  @import "../../../../assets/css/custom.css";
</style>
